function canvasApp() {
  var displayCanvas: HTMLCanvasElement = document.getElementById(
    "displayCanvas"
  ) as HTMLCanvasElement;
  var context = displayCanvas.getContext("2d");
  var displayWidth = displayCanvas.width;
  var displayHeight = displayCanvas.height;

  var buffer: any;
  var imageData: ImageData;
  var pixelData: any;
  var maps: any;
  var colors: any;
  var bgColor: string;
  var urlColor: string;
  var applyBubble: boolean;
  var maxIter: number;

  var lowPoints = 1000000;
  var medPoints = 10000000;
  var highPoints = 100000000;

  var rbFixColors = false;
  var rbGrayscale = false;
  var rbNumPoints1 = false;
  var rbNumPoints2 = true;

  var cbShorterVectors = false;
  var cbShowMaps = false;
  var cbHighGamma = false;

  var cbNoReflection = false;

  return init();

  function init() {
    bgColor = "#000000";
    urlColor = "#222222";
    if (rbNumPoints1) {
      maxIter = lowPoints;
    } else if (rbNumPoints2) {
      maxIter = medPoints;
    } else {
      maxIter = highPoints;
    }

    setUpBuffer();
    setCoeffs();
    setColors();
    generate();
    return exportPressed();
  }

  function setUpBuffer() {
    var i;
    buffer = [];
    for (i = 0; i < displayHeight * displayWidth; i++) {
      buffer.push(0);
    }
  }

  function setCoeffs() {
    var x1, y1, x0, y0;
    var numMatrices = 2 + Math.floor(Math.random() * 5);

    var angle1, angle2, rad1, rad2;
    var transX, transY;
    var rotAngle;
    var skewAngle;
    var rotAngleMax;
    var skewAngleMax;
    var maxScale;
    var minScale;
    var cbLessRotation = false;

    if (cbLessRotation) {
      rotAngleMax = Math.PI / 12;
    } else {
      rotAngleMax = 2 * Math.PI;
    }

    skewAngleMax = Math.PI / 12;

    if (cbShorterVectors) {
      maxScale = 0.67;
      minScale = 0.33;
    } else {
      maxScale = 1;
      minScale = 0.4;
    }

    maps = [];
    for (var i = 0; i < numMatrices; i++) {
      rotAngle = (1 - 2 * Math.random()) * rotAngleMax;
      skewAngle = (1 - 2 * Math.pow(Math.random(), 3)) * skewAngleMax;
      angle1 = rotAngle + skewAngle;
      angle2 = rotAngle - skewAngle;
      if (cbNoReflection) {
        rad1 = minScale + Math.random() * (maxScale - minScale);
        rad2 = minScale + Math.random() * (maxScale - minScale);
      } else {
        rad1 =
          (Math.random() < 0.5 ? -1 : 1) *
          (minScale + Math.random() * (maxScale - minScale));
        rad2 =
          (Math.random() < 0.5 ? -1 : 1) *
          (minScale + Math.random() * (maxScale - minScale));
      }

      x0 = rad1 * Math.cos(angle1);
      y0 = rad1 * Math.sin(angle1);
      x1 = -rad2 * Math.sin(angle2);
      y1 = rad2 * Math.cos(angle2);

      var maxX = Math.abs(x0) + Math.abs(x1);
      if (maxX > 1) {
        //scale down the whole matrix
        x0 /= maxX;
        x1 /= maxX;
        y0 /= maxX;
        y1 /= maxX;
      }
      var maxY = Math.abs(y0) + Math.abs(y1);
      if (maxY > 1) {
        x0 /= maxY;
        x1 /= maxY;
        y0 /= maxY;
        y1 /= maxY;
      }

      transX =
        Math.pow(Math.random(), 0.5) *
        (Math.random() < 0.5 ? -1 : 1) *
        (1 - Math.abs(x0) - Math.abs(x1));
      transY =
        Math.pow(Math.random(), 0.5) *
        (Math.random() < 0.5 ? -1 : 1) *
        (1 - Math.abs(y0) - Math.abs(y1));

      var mat = {
        a: x0,
        b: x1,
        c: y0,
        d: y1,
        tx: transX,
        ty: transY,
      };
      maps.push(mat);
    }
  }

  function setColors() {
    var numColorsToAdd;

    var colorMin = 48;
    var colorMax = 255;
    var r0, g0, b0;
    var maxComponent;

    if (!rbFixColors) {
      colors = [];
    }

    if (maps.length < colors.length) {
      return;
    } else {
      numColorsToAdd = maps.length - colors.length;
    }

    for (var i = 0; i < numColorsToAdd; i++) {
      r0 = colorMin + Math.random() * (colorMax - colorMin);
      g0 = colorMin + Math.random() * (colorMax - colorMin);
      b0 = colorMin + Math.random() * (colorMax - colorMin);

      maxComponent = Math.max(r0, Math.max(g0, b0));

      var col = {
        r: Math.round((255 / maxComponent) * r0),
        g: Math.round((255 / maxComponent) * g0),
        b: Math.round((255 / maxComponent) * b0),
        //r: 255,
        //g: 255,
        //b: 255
      };
      colors.push(col);
    }
  }

  function mapTextArray() {
    var j;
    var string;
    var stringArray: string[] = [];
    for (j = 0; j < maps.length; j++) {
      var map = maps[j];
      string = "[" + map.a + ", " + map.b + ", " + map.tx + "]";
      stringArray.push(string);
      string = "[" + map.c + ", " + map.d + "," + map.ty + "]";
      stringArray.push(string);
      stringArray.push(""); //line space
    }
    return stringArray;
  }

  function generate() {
    var ignoreCount = 20;
    var i;
    var x, y;
    var numFunctions = maps.length;
    var pixelX, pixelY;
    var index;
    var index4;
    var mapIndex;
    var tempX;
    var matrix;
    var r, g, b;
    var color;
    var maxCount = 0;
    var grayscale = rbGrayscale;
    var gammaRecip;
    var bubbleFactor;
    var bufferAmt;
    var halfWidth = displayWidth / 2;
    var halfHeight = displayHeight / 2;

    /*
		Debugger.log("maps:");
		for (j = 0; j < maps.length; j++) {
			var map = maps[j];
			Debugger.log(mapText());
		}
		*/

    if (cbHighGamma) {
      gammaRecip = 0.3;
    } else {
      gammaRecip = 0.45;
    }

    //background color
    if (context) {
      context.fillStyle = "#000000";
      context.fillRect(0, 0, displayWidth, displayHeight);
    }

    //set up image data
    if (context) {
      imageData = context.getImageData(0, 0, displayWidth, displayHeight);
      pixelData = imageData.data;
    }

    x = 1 - 2 * Math.random();
    y = 1 - 2 * Math.random();

    r = g = b = 0;

    for (i = 0; i < maxIter; ++i) {
      //pick a random map and apply it
      //Note ~~() does same thing as Math.floor() if the argument is positive.
      matrix = maps[(mapIndex = ~~(numFunctions * Math.random()))];
      tempX = matrix.a * x + matrix.b * y + matrix.tx;
      y = matrix.c * x + matrix.d * y + matrix.ty;
      x = tempX;

      if (applyBubble) {
        bubbleFactor = 4.5 / (4 + Math.sqrt(x * x + y * y));
        x *= bubbleFactor;
        y *= bubbleFactor;
      }

      if (!grayscale) {
        color = colors[mapIndex];
        r = (r + color.r) * 0.5;
        g = (g + color.g) * 0.5;
        b = (b + color.b) * 0.5;
      }

      if (i > ignoreCount) {
        pixelX = Math.round((x + 1) * halfWidth);
        pixelY = Math.round((y + 1) * halfHeight);

        if (
          pixelX < displayWidth &&
          pixelY < displayHeight &&
          pixelX >= 0 &&
          pixelY >= 0
        ) {
          //write to buffer and image data
          index = Math.floor(pixelY * displayWidth + pixelX);
          index4 = 4 * index;

          bufferAmt = ++buffer[index];

          if (bufferAmt > maxCount) {
            maxCount = bufferAmt;
          }

          if (grayscale) {
            pixelData[index4] = 255;
            pixelData[index4 + 1] = 255;
            pixelData[index4 + 2] = 255;
          } else {
            pixelData[index4] =
              (bufferAmt * pixelData[index4] + r) / (bufferAmt + 1);
            pixelData[index4 + 1] =
              (bufferAmt * pixelData[index4 + 1] + g) / (bufferAmt + 1);
            pixelData[index4 + 2] =
              (bufferAmt * pixelData[index4 + 2] + b) / (bufferAmt + 1);
          }
        }
      }
    }

    //render
    //loop through whole display and set alpha according to count
    var len = displayWidth * displayHeight;
    var ln2Recip = 1 / Math.LN2;
    var maxCountRecip = 1 / maxCount;
    var alphaIndex = 3;
    for (i = 0; i < len; ++i) {
      if (buffer[i] !== 0) {
        pixelData[alphaIndex] = Math.floor(
          Math.pow(
            Math.log(1 + buffer[i] * maxCountRecip) * ln2Recip,
            gammaRecip
          ) * 255
        );
      }
      alphaIndex += 4;
    }

    if (context) {
      //draw display
      context.putImageData(imageData, 0, 0);

      //draw solid background - needs to be done because there are low-alpha pixels in display now.
      context.globalCompositeOperation = "destination-over";
      context.fillStyle = "#000000";
      context.fillRect(0, 0, displayWidth, displayHeight);
      context.globalCompositeOperation = "source-over";
    }
  }

  function exportPressed() {
    var lineSpacing = 11;
    var URLmargin = 30;
    var stringArray: string[] = [];

    var exportHeight;
    if (cbShowMaps) {
      stringArray = mapTextArray();
      exportHeight =
        URLmargin + displayHeight + stringArray.length * lineSpacing + 5;
      if (applyBubble) {
        exportHeight += lineSpacing + 10;
      }
    } else {
      exportHeight = URLmargin + displayHeight;
    }

    //off screen canvas used only when exporting image
    var exportCanvas = document.createElement("canvas");
    exportCanvas.width = displayWidth;
    exportCanvas.height = exportHeight;
    var exportCanvasContext = exportCanvas.getContext("2d")!;

    //background - otherwise background will be transparent.
    exportCanvasContext.fillStyle = bgColor;
    exportCanvasContext.fillRect(0, 0, displayWidth, exportHeight);

    //draw
    exportCanvasContext.drawImage(
      displayCanvas,
      0,
      0,
      displayWidth,
      displayHeight,
      0,
      URLmargin,
      displayWidth,
      displayHeight
    );

    //add printed url to image
    exportCanvasContext.fillStyle = urlColor;
    exportCanvasContext.font = "bold italic 16px Helvetica, Arial, sans-serif";
    exportCanvasContext.textBaseline = "top";
    var metrics = exportCanvasContext.measureText("");
    exportCanvasContext.fillText("", displayWidth - metrics.width - 10, 5);

    //print maps
    if (cbShowMaps) {
      exportCanvasContext.font = "bold 10px Helvetica, Arial, sans-serif";
      var lineY = URLmargin + displayHeight + 5;
      for (var i = 0; i < stringArray.length; i++) {
        exportCanvasContext.fillText(stringArray[i], 5, lineY);
        lineY += lineSpacing;
      }
      if (applyBubble) {
        exportCanvasContext.fillText(
          'with nonlinear "bubble" variation f(x,y) = 4.5/(4+r^2)*(x,y)',
          5,
          lineY
        );
      }
    }

    //we will open a new window with the image contained within:
    //retrieve canvas image as data URL:
    var dataURL = exportCanvas.toDataURL("image/png");
    return dataURL;
  }
}

export default canvasApp;
